export const Animation = {
  DEFAULT_DURATION: 500,
};
